import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ru from './ru.json';

// Определяем язык вручную через GeoIP + navigator
const getInitialLang = () => {
    const userLang = navigator.language || navigator.userLanguage;
    const langCode = userLang.split('-')[0]; // "en", "ru", "uk", и т.д.

    // если страна Украина или Россия — русский
    if (['ru', 'uk'].includes(langCode)) {
        return 'ru';
    }

    return 'en';
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ru: { translation: ru }
        },
        lng: getInitialLang(), // устанавливаем язык
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
